





























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Ticket from "../../store/entities/ticket";
import Editor from "@tinymce/tinymce-vue";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import TinymceInit from "../../lib/TinymceInit";
import Ajax from "@/lib/ajax";

TinymceInit.height = 300;
@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class EditTicket extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: false }) ticketId: number;

  tinymceInit = TinymceInit;
  ticket: Ticket = new Ticket();
  type: boolean = false;
  showOnHome: boolean = false;
  supplierList: Array<any> = [];
  courtList: any = [];

  get extData() {
    return {
      ticketId: this.ticket.id,
    };
  }
  async datetimeChange(e) {
    if (e) {
      this.ticket.endTime = e;
    }
  }
  /**
   * @description:获取供应商key and  value
   */
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  save() {
    (this.$refs.ticketForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "ticket/update",
          data: {
            ticket: this.ticket,
            images: this.ticket.ticketImages,
          },
        });
        (this.$refs.ticketForm as any).resetFields();
        this.$Message.success({
          content: "修改成功",
        });

        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  deleteImg(id) {
    if (id > 0) {
      this.$store
        .dispatch({
          type: "ticket/deleteImg",
          data: {
            id,
          },
        })
        .then((res) => {
          if (res) {
            this.$Message.success({
              content: "删除成功",
            });
          }
        });
    }
  }
  cancel() {
    (this.$refs.ticketForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      // this.ticket= this.$store.state.ticket.editTicket
      this.getCourtList();
      this.getSupplierList();
      this.ticket = Util.extend(true, {}, this.$store.state.ticket.editTicket);
    }
  }
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  async validateRegionId(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择地区"));
    } else {
      callback();
    }
  }
  validateStartTime(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择开始时间"));
    } else {
      callback();
    }
  }
  validateEndTime(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择结束时间"));
    } else {
      callback();
    }
  }
  ticketRule = {
    name: [
      {
        required: true,
        message: "请输入名称",
        trigger: "blur",
      },
    ],
    flow: [
      {
        required: true,
        message: "请输入使用流程",
        trigger: "blur",
      },
    ],
    startTime: [
      {
        required: true,
        message: "请选择开始日期",
        validator: this.validateStartTime,
        trigger: "blur change",
      },
    ],
    endTime: [
      {
        required: true,
        message: "请选择结束日期",
        validator: this.validateEndTime,
        trigger: "blur change",
      },
    ],
    regionId: [
      {
        required: true,
        validator: this.validateRegionId,
        trigger: "change",
      },
    ],
    useRole: [
      {
        required: true,
        message: "请输入使用规则",
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: "请输入产品说明",
        trigger: "blur",
      },
    ],
  };
}
